/**
 * url utils
 *
 * @author Shigq
 * @date 2021/12/13 14:55
 */
const { isIP } = require('./validator')

function getSubDomain() {
	try {
		let subdomain = ''
		const {domain} = document
		const domainList = domain.split('.')

		// handle ip
		if (isIP(domain)) {
			let level3domain = document.domain;
			let pattern = /^.*?\b\.\b/;
			return level3domain.replace(pattern, '');
		}

		// handle localhost - local
		if (domain === 'localhost') {
			return ''
		}

		const urlItems = []
		urlItems.unshift(domainList.pop())

		while (urlItems.length < 2) {
			urlItems.unshift(domainList.pop())
			subdomain = urlItems.join('.')
		}

		return subdomain || document.domain
	} catch (e) {
		console.log('@libs/utils#url-utils#getSubDomain###error', e)

		return document.domain
	}
}

module.exports = {
	getSubDomain
}
